import React from 'react';
import ActionButton from '../../action-button';
import { useEditorHeaderContext } from '../context';
import withPopover from '../hoc/with-popover';

const PublishButton = ({ label, ...props }) => {
  const { isLg } = useEditorHeaderContext();

  return (
    <ActionButton
      {...props}
      label={isLg ? label : undefined}
      iconPlacement="before"
      iconGlyph={isLg ? undefined : 'publish'}
      format="solid"
      size="small"
      appearance="accent"
    />
  );
};

export default withPopover(PublishButton);
